import type { RouteLocationRaw, Router } from 'vue-router'

import { isString } from '/@/neolix-utils/src/index'

import { PageEnum } from '/@/enums/pageEnum'
import { unref } from 'vue'

import { useRouter } from 'vue-router'
import { REDIRECT_NAME } from '/@/router/constant'

export type RouteLocationRawEx = Omit<RouteLocationRaw, 'path'> & { path: PageEnum; query: any }

function handleError(e: Error) {
  console.error(e)
}

// page switch
export function useGo(_router?: Router) {
  let router
  if (!_router) {
    router = useRouter()
  }
  const { push, replace } = _router || router
  function go(opt: PageEnum | RouteLocationRawEx | string = PageEnum.BASE_HOME, isReplace = false) {
    if (!opt) {
      return
    }
    if (isString(opt)) {
      isReplace ? replace(opt).catch(handleError) : push(opt).catch(handleError)
    } else {
      const o = opt as RouteLocationRaw
      isReplace ? replace(o).catch(handleError) : push(o).catch(handleError)
    }
  }
  return go
}

/**
 * @description: redo current page
 */
export const useRedo = (_router?: Router) => {
  const { push, currentRoute } = _router || useRouter()
  const { query, params = {}, fullPath, path } = unref(currentRoute.value)
  function redo(): Promise<boolean> {
    return new Promise((resolve) => {
      params._redirect_type = 'path'
      params.path = fullPath || path
      // push({ path: `/redirect/${path.startsWith('/') ? path.slice(1) : path}`, params, query }).then(() => resolve(true))
      push({ name: REDIRECT_NAME, params, query }).then(() => resolve(true))
    })
  }
  return redo
}
